// @flow
const cleanCaption = (caption: string) => caption.replace(/<\/?WARNING>/g, '');

export default cleanCaption;



// WEBPACK FOOTER //
// ./src/components/ContentSection/MediaViewer/cleanCaption.js